<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "commondescr",
      key: "id",
      url: {
        get: `/admin/system/hospitalArea`,
        add: `/admin/system/hospitalArea`,
        edit: "/admin/system/hospitalArea",
      },
      id: "",
      typeId: "",
      items: [
        {
          label: "院区名称",
          name: "areaName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, message: "院区名称不能为空", trigger: "blur" }],
        },
        {
          label: "地址",
          name: "areaAddress",
          value: "",
          width: "400px",
          type: "input",
        },
      ],
      forms: {},
    };
  },
  props: ["onCancel", "ids", "actions"],
  mounted() { },
  created() {
    if (this.actions == "edit") {
      this.id = this.ids;
      this.handleSearch();
    }
  },
  methods: {
    async handleSearch() {
      let res = await $utils.api.load(`/admin/system/hospitalArea/${this.ids}`);
      try {
        if (res) {
          this.forms = res.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleSubmit() {
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        this.sloading = true;
        $utils.api
          .load(`/admin/system/hospitalArea`, q, this.actions == "edit" ? "PUT" : "POST")
          .then((res) => {
            this.sloading = false;
            if (res.status) {
              $utils.toast.success("保存成功");
              this.$emit("onCancel");
              $utils.url.go(0);
            }
          })
          .catch((e) => {
            this.sloading = false;
            $utils.toast.error("保存异常" + e.message);
          });
      });
    },
  },
};
</script>
